import React from 'react';
import { connect } from 'react-redux';
import { InputGroup, InputGroupAddon, Button, InputGroupText } from 'shards-react';

const Pagination = ({ pagesLength, divaTotalPages, currentPage, setPageToDisplay }) => {
	const goToPage = (pageNumber) => {
		if (pageNumber === currentPage || pageNumber < 0 || pageNumber > pagesLength - 1) return;
		return setPageToDisplay({ actual: pageNumber });
	};

	return (
		<InputGroup className='justify-content-center m-0 dynamic-width'>
			<InputGroupAddon type='prepend'>
				<Button theme='warning' className='first-page  p-2' onClick={() => {
					if (currentPage.toString().includes('diva')) {
						goToPage(`diva-original-${1}`)
					} else {
						goToPage(0)
					}
				}}>
					<i className='fas fa-angle-double-left' />
				</Button>
			</InputGroupAddon>
			<InputGroupAddon type='prepend'>
				<Button theme='warning' className='previous-page  pl-2' onClick={() => {
					if (currentPage.toString().includes('diva')) {
						const pattern = '-([0-9]{1,})';
						const regex = new RegExp(pattern, 'gi');
						const divaPgNum = Number(regex.exec(currentPage)[1]) - 1
						if (divaPgNum > 0) {
							const newPage = currentPage.replace(/-\d{1,}/g, `-${divaPgNum}`)
							goToPage(newPage)
						}
					} else {
						goToPage(currentPage - 1)
					}
				}}>
					<i className='fas fa-angle-left' />
				</Button>
			</InputGroupAddon>
			<InputGroupText
				className='text-dark justify-content-center cursor-default font-weight-bold'
			>
				{(pagesLength || divaTotalPages) && currentPage.toString().includes('diva') ? 
					`DiVA Seite ${currentPage.split('-')[currentPage.split('-').length - 1]} von ${divaTotalPages}`
						: `Seite ${currentPage + 1} von ${pagesLength}`}
			</InputGroupText>
			<InputGroupAddon type='append'>
				<Button theme='warning' className='next-page  pr-2' onClick={() => {
					if (currentPage.toString().includes('diva')) {
						const pattern = '-([0-9]{1,})';
						const regex = new RegExp(pattern, 'gi');
						const divaPgNum = Number(regex.exec(currentPage)[1]) + 1
						if (divaPgNum <= divaTotalPages) {
							const newPage = currentPage.replace(/-\d{1,}/g, `-${divaPgNum}`)
							goToPage(newPage)
						}
					} else {
						goToPage(currentPage + 1)
					}
				}}>
					<i className='fas fa-angle-right' />
				</Button>
			</InputGroupAddon>
			<InputGroupAddon type='append'>
				<Button theme='warning' className='last-page  p-2' onClick={() => {
					if (currentPage.toString().includes('diva')) {
						goToPage(`diva-original-${divaTotalPages}`)
					} else {
						goToPage(pagesLength - 1)
					}
				}}>
					<i className='fas fa-angle-double-right' />
				</Button>
			</InputGroupAddon>
		</InputGroup>
	);
};

/**
 * Take the pages and pages length of saved in redux document and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument }) => {
	const divaTotalPages = savedDocument.diva?.divaTotalPages
	const pagesLength = savedDocument.pagesLength

	return { pagesLength, divaTotalPages }
};

export default connect(mapStateToProps)(Pagination); //Export component and connect it with redux.
